/**
 * @generated SignedSource<<ffc502d5713447b5434aecc822b7217a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectExpandableMenuItem$data = {
  readonly avatar: {
    readonly large: string;
  };
  readonly isFavourite: boolean | null;
  readonly name: string;
  readonly projectId: string;
  readonly projectKey: string;
  readonly projectType: JiraProjectType | null;
  readonly " $fragmentType": "ProjectExpandableMenuItem";
};
export type ProjectExpandableMenuItem$key = {
  readonly " $data"?: ProjectExpandableMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExpandableMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectExpandableMenuItem",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "large"
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "12cc08f1c0e66ef33794188ba0f98544";

export default node;
